// API Configuration
import { getCurrentApiUrl } from '@/utils/apiUtils';

// Helper function to clean URL and remove trailing slashes and duplicate /api
const cleanUrl = (url: string): string => {
  // Remove trailing slashes
  let clean = url.replace(/\/+$/, '');
  // Remove /api if it's at the end
  if (clean.endsWith('/api')) {
    clean = clean.substring(0, clean.length - 4);
  }
  return clean;
};

export const API_CONFIG = {
  // Base URL for API requests (will be set dynamically)
  get BASE_URL() {
    return cleanUrl(getCurrentApiUrl());
  },
  
  // For reference, keep the environment variable
  ENV_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000/api', 
  
  // API Endpoints - these should NOT start with /api since we're handling it in getUrl
  ENDPOINTS: {
    AUTH: '/api/auth',
    USERS: '/api/users',
    ROLES: '/api/roles',
    PATIENTS: '/api/patients',
    DEPARTMENTS: '/api/departments',
    EMPLOYEES: '/api/employees',
    APPOINTMENTS: '/api/appointments',
    APPOINTMENT_ORDERS: '/api/appointment-orders',
    LOCATIONS: '/api/locations',
    DOCUMENTS: '/api/documents',
    PAYMENT_RECEIVE: '/api/payment-receive',
    PAYMENT_RECEIVE_ORDER: '/api/payment-receive-order',
    CHART_OF_ACCOUNTS: '/api/chart-of-accounts',
    CREDIT_DEBIT_TRACKER: '/api/credit-debit-tracker',
    ITEMS: '/api/items',
    ITEM_BATCHES: '/api/item-batches',
    ITEM_LOCATIONS: '/api/item-locations',
    INVENTORY: '/api/inventory',
    REPORT: '/api/appointment-orders/report',
    REPORT_ADVANCED: '/api/appointment-orders/report/advanced',
    // Add other endpoints here as needed
  },
  
  // Helper function to get full URL
  getUrl: (endpoint: string): string => {
    const base = API_CONFIG.BASE_URL;
    // Ensure endpoint starts with a single slash
    const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    
    // Combine base URL and endpoint, ensuring no double slashes
    let url = base + normalizedEndpoint;
    
    // Replace any occurrence of // with / except after http(s):
    return url.replace(/([^:])\/\//g, '$1/');
  }
};

// Helper function to get base URL
export const getApiBaseUrl = (): string => {
  // Remove any trailing slashes and /api if it exists to avoid double /api
  let baseUrl = API_CONFIG.BASE_URL;
  if (baseUrl.endsWith('/api')) {
    baseUrl = baseUrl.substring(0, baseUrl.length - 4);
  } else if (baseUrl.endsWith('/')) {
    baseUrl = baseUrl.slice(0, -1);
  }
  return baseUrl;
};

export default API_CONFIG;
